import { Play, ArrowDown } from "lucide-react";
import { Button } from "../custom_ui/button.tsx";
import {heroBg} from "../../assets/";

interface HeroSectionProps {
  content?: {
    hero_bg_image?: string;
    hero_subtitle?: string;
    hero_title?: string;
    hero_description?: string;
  };
}

export function HeroSection({ content }: HeroSectionProps) {
  return (
    <section
      id="home"
      className="relative min-h-screen w-full max-w-full flex items-center justify-center overflow-hidden p-0 m-0"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
          <img
            src={content?.hero_bg_image || heroBg}
            alt="Baaj Media - Featured Song"
            className="w-full h-full object-cover"
          />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center pt-20 ">
        <div className="max-w-4xl mx-auto">
          <p
            className="text-primary font-medium tracking-[0.3em] uppercase mb-6 animate-fade-up"
            style={{ animationDelay: "0.2s" }}
          >
            {content?.hero_subtitle || "Digital Marketing Excellence"}
          </p>
          
          <h1
            className="font-display text-5xl md:text-7xl lg:text-8xl text-foreground leading-tight mb-6 animate-fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            {content?.hero_title || "WE BRING YOUR VISION TO LIFE"}
          </h1>
          
          <p
            className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 animate-fade-up"
            style={{ animationDelay: "0.6s" }}
          >
            {content?.hero_description || "Transform your digital presence with cutting-edge marketing strategies, viral promotions, and content that captivates audiences worldwide."}
          </p>

          <div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-up"
            style={{ animationDelay: "0.8s" }}
          >
            {/* <Button variant="hero" size="xl" className="gap-3">
              <Play size={20} />
              Watch Showreel
            </Button>
            <Button variant="hero-outline" size="xl">
              Explore Services
            </Button> */}
          </div>
        </div>

       
      </div>
      <div className="absolute bottom-0 w-full -translate-x-0 z-20">
      <div
        className=" bottom-0 z-20"
      >
        <div className="animate-fade-up" style={{ animationDelay: "1s" }} id="features">
          <a
            href="#features"
            className="flex flex-col items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
          >
            <span className="text-sm tracking-wider text-white">Scroll to explore</span>
            <ArrowDown className="animate-bounce text-primary" size={24} />
          </a>
        </div>
      </div>
      </div>
    </section>
  );
}
